import React from 'react';
import { Link } from 'react-router-dom';
import './HomePageLanding.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';

const HomePageLanding = () => {
  return (
    <div className="homepagelanding">
      <div className="content">
        <h1 className="main-text">Building Dreams, Designing Spaces - Across Bihar</h1>
        <p className="sub-text">Leading construction and interior design across Bihar. We build quality homes and commercial spaces,
          crafting inspiring interiors with innovation and a client-focused approach.
          From construction to bespoke design for residential, commercial, and hospitality sectors.
          Let's bring your vision to life. Contact us to start your project.</p>
        <Link to="/projects">
          <button className="call-to-action">
            Projects <FontAwesomeIcon icon={faArrowUp} className="arrow" />
          </button>
        </Link>
      </div>
      
    </div>
  );
};

export default HomePageLanding;